import type { FilterOption } from 'features/filters/types'
import type {
  AgentConfig,
  FilterCriterion,
  SavedFilters,
} from 'features/trend-detection/types'
import {
  expandCriterion,
  formatCriterionExpanded,
} from 'features/trend-detection/utils/helpers'

export interface FilterChip {
  key: string
  label: string
  fieldLabel: string
  values: string[]
  /** Date-range prose (no discrete values); overrides `values` when set. */
  singleLine?: string
}

/**
 * `filterOptions` must be passed for UUID → pretty-name resolution — project /
 * theme / dataset UUIDs otherwise print raw.
 */
export function summarizeCriteria(
  criteria: FilterCriterion[] | undefined | null,
  filterOptions?: FilterOption[],
): FilterChip[] {
  if (!criteria) return []
  const chips: FilterChip[] = []
  for (const criterion of criteria) {
    const label = formatCriterionExpanded(criterion, filterOptions, 10)
    if (!label) continue
    const expanded = expandCriterion(criterion, filterOptions)
    chips.push({
      key: criterion.field,
      label,
      fieldLabel: expanded?.fieldLabel ?? criterion.field,
      values: expanded?.values ?? [],
      singleLine: expanded?.singleLine,
    })
  }
  return chips
}

export function summarizeFilters(
  filters: AgentConfig['filters'],
  filterOptions?: FilterOption[],
): FilterChip[] {
  if (!filters) return []
  const saved = filters as SavedFilters
  return summarizeCriteria(
    Array.isArray(saved.criteria) ? saved.criteria : [],
    filterOptions,
  )
}
